import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 512 512"

const ChevronLeftIcon = createSvgIcon(
  <>
    <g>
      <path
        d='M129,266.5c2.6,0,5.3-1,7.3-3l254-245.5c4.2-4,4.3-10.7,0.3-14.9c-4-4.2-10.7-4.3-14.9-0.3l-254,245.5   c-4.2,4-4.3,10.7-0.3,14.9C123.5,265.5,126.2,266.5,129,266.5z'
        fill='#6A6E7C'
      />
      <path
        d='M383,512c2.8,0,5.5-1.1,7.6-3.2c4-4.2,3.9-10.9-0.3-14.9l-254-245.5c-4.2-4-10.9-3.9-14.9,0.3   c-4,4.2-3.9,10.9,0.3,14.9l254,245.5C377.7,511,380.4,512,383,512z'
        fill='#6A6E7C'
      />
    </g>
  </>,
  'ChevronLeftIcon'
)

export default ChevronLeftIcon
